class DOBProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(type, e) {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');

        if ((type === 'mm' || type === 'dd') && e.target.value.length > 2)
            return;

        if (type === 'yyyy' && e.target.value.length > 4)
            return;
        
        var date = this.props.value;

        var y = type !== 'yyyy' ? date[0]+date[1]+date[2]+date[3] : e.target.value;
        var m = type !== 'mm' ? date[5]+date[6] : e.target.value;
        var d = type !== 'dd' ? date[8]+date[9] : e.target.value;
        
        while (y.length < 4) { y = '0'+y; }
        while (m.length < 2) { m = '0'+m; }
        while (d.length < 2) { d = '0'+d; }

        this.props.onChange(this.props.field, y+'-'+m+'-'+d)
    }

    formatPriceInput(val) {
        if (val.length === 1 && val[0] === '0')
            return '';

        val = val.replace(/[^0-9]/g, '');

        return val;
    }

    render() {
        var self = this;

        var date = this.props.value;
        var uuid = this.state.uuid;
        
        var y = date[0]+date[1]+date[2]+date[3];
        var m = date[5]+date[6];
        var d = date[8]+date[9];

        if (y === '0000')
            y = '';

        if (m === '00')
            m = '';

        if (d === '00')
            d = '';

        for (var i=0; i<4; i++) {
            if (y[0] === '0')
                y = y.substr(1);
        }

        for (var i=0; i<2; i++) {
            if (m[0] === '0')
                m = m.substr(1);
        }

        for (var i=0; i<2; i++) {
            if (d[0] === '0')
                d = d.substr(1);
        }
        
        var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        var days   = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
        var years  = [];

        for(var i = this.props.year ? this.props.year : 2042; i >= 1900; --i) {
            years.push(i);
        }        

        return (
            <div
                className={'dob-profile '+this.props.className}
                style={(this.props.float ? {'float' : 'left'} : {})}>

                { this.props.title &&
                    <div className='dob-profile__title'>
                        {this.props.title}
                    </div>
                }

                <div className='row no-gutters'>
                    <div className='col-4'>
                        <select
                            value={m}
                            className='dob-profile__input'
                            onChange={this.onChange.bind(this, 'mm')}>

                            <option value='00'>--</option>

                            { months.map((month) => {
                                return (
                                    <option
                                        value={month}
                                        key={'month-'+uuid+month}>

                                        {month}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className='col-4'>
                        <select
                            value={d}
                            className='dob-profile__input'
                            onChange={this.onChange.bind(this, 'dd')}>

                            <option value='00'>--</option>

                            { days.map((day) => {
                                return (
                                    <option
                                        value={day}
                                        key={'day-'+uuid+day}>

                                        {day}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className='col-4'>
                        <select
                            value={y}
                            className='dob-profile__input'
                            onChange={this.onChange.bind(this, 'yyyy')}
                            style={{'width':'100%'}}>

                            <option value='0000'>--</option>

                            { years.map((year) => {
                                return (
                                    <option
                                        value={year}
                                        key={'year-'+uuid+year}>

                                        {year}
                                    </option>
                                );
                            })}
                        </select>
                    </div>                        
                </div>
            </div>
        );
    }
}

export default DOBProfile;


/*
            <div
                className={'dob-profile '+this.props.className}
                style={(this.props.float ? {'float' : 'left'} : {})}>

                { this.props.title &&
                    <div className='dob-profile__title'>
                        {this.props.title}
                    </div>
                }
                
                <select
                    value={m}
                    onChange={this.onChange.bind(this, 'mm')}
                    style={{'width':'60px'}} >

                    <option value='00'>--</option>

                    { months.map((month) => {
                        return (
                            <option
                                value={month}
                                key={'month-'+uuid+month}>

                                {month}
                            </option>
                        );
                    })}
                </select>

                <select
                    value={d}
                    onChange={this.onChange.bind(this, 'dd')}
                    style={{'width':'60px'}} >

                    <option value='00'>--</option>

                    { days.map((day) => {
                        return (
                            <option
                                value={day}
                                key={'day-'+uuid+day}>

                                {day}
                            </option>
                        );
                    })}
                </select>

                <select
                    value={y}
                    onChange={this.onChange.bind(this, 'yyyy')}
                    style={{'width':'80px'}} >

                    <option value='0000'>--</option>

                    { years.map((year) => {
                        return (
                            <option
                                value={year}
                                key={'year-'+uuid+year}>

                                {year}
                            </option>
                        );
                    })}
                </select>

            </div>
*/


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/DOBProfile.react.jsx